import { browserHistory } from 'react-router';
import { change } from 'redux-form';
import { delay, call, put, select, take, takeEvery, takeLatest, all, fork } from 'redux-saga/effects';

import * as api from '../../services/csv_record/api_csv_record';
//import * as apiCSVStatus from '../../services/csv_status/api_csv_status';

import * as common from '../sagasCommon';
import * as apiCommon from '../../services/apiCommon';
import * as SagasType from '../../constants/constant_saga_types';
import * as DocType from '../../constants/constant_doc_types';

export default function* (app) {
  return yield all([
    fork(deleteCSVRecordFromListSaga, app),
    fork(deleteCSVRecordSaga, app),
    fork(fetchCSVRecordForEditSaga, app),
    fork(fetchListCSVRecordSaga, app),
    fork(saveCSVRecordSaga, app),
    fork(startImportSaga, app),
  ]);
}

export function* fetchListCSVRecordSaga(app) {
  yield takeLatest('FETCH_LIST_CSV_RECORD', callListCSVRecord, app);
}
function* callListCSVRecord(app, action) {
  const { filters, silent } = action;
  
  yield common.showProgressListTable(silent);
  try {
    const dataParams = { filters, list_type: 'csv_record' };
    const tableData = yield call(apiCommon.getDocs, app, dataParams);
    yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}

export function* deleteCSVRecordFromListSaga(app) {
  yield takeEvery('DELETE_CSV_RECORD_FROM_LIST', callDeleteCSVRecordFromList, app);
}

function* callDeleteCSVRecordFromList(app, action) {
  yield deleteCSVRecord(app, action);
  yield delay(2000); 
  yield callListCSVRecord(app, { silent: true });
}

function* deleteCSVRecord(app, action) {
  yield put({ type: 'DELETE_RECORD_INPROGRESS' });
  try {
    const { id } = action;
    let result = null;
    if (id) {
      const state = yield select();
      const { tenant, user } = state;
      const { id } = action;
      const params = { tenant, user, id };
      result = yield call(api.deleteCSVRecord, app, params);
    }
    yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.CSV_RECORD } });
    return result;
  } catch (error) {
    yield put({ type: 'DELETE_RECORD_ERROR', error })
  }
}


export function* deleteCSVRecordSaga(app) {
  yield takeEvery('DELETE_CSV_RECORD', callDeleteCSVRecord, app);
}

function* callDeleteCSVRecord(app, action) {
  const result = yield deleteCSVRecord(app, action);
  yield delay(2000); 
  if (result) {
    browserHistory.push('/admin/import_csv');
  }
}

export function* fetchCSVRecordForEditSaga(app) {
  yield takeEvery('FETCH_CSV_RECORD_FOR_EDIT', callFetchCSVRecordForEdit, app);
}

function* callFetchCSVRecordForEdit(app, action) {
  const { tenant, user } = yield select();
  const { id, silent } = action;
  try {
    if (id) {
      yield common.showProgressDataById(silent);
      const fetchParams = { tenant, user, id };
      const doc = yield call(api.fetchCSVRecordById, app, fetchParams);
      console.log("fetchCSVRecordForEdit", doc);
      yield common.doneDataById(doc);
    }
  } catch (error) {
    yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
  }
}



export function* saveCSVRecordSaga(app) {
  yield takeEvery(["SAVE_CSV_RECORD", "SAVE_IMPORT_CSV_RECORD"], callSaveCSVRecord, app);
}
function* callSaveCSVRecord(app, action) {
  try {
    yield common.showProgressSaveRecord();
    const { tenant, user } = yield select();
    const { data, type } = action;

    const result = yield call(api.saveCSVRecord, app, {
      tenant,
      user,
      data
    });

    const { id, reference_id } = result || {};
    yield call(api.uploadCsvFile, app, id, data.csv);

    if (id) {
      if (type === 'SAVE_IMPORT_CSV_RECORD') {
        yield put({ type: SagasType.START_CSV_IMPORT, id, reference_id });
        yield common.doneSaveRecord(result, 'CSV record was saved');
      } else {
        yield callFetchCSVRecordForEdit(app, { id, silent: true });
        browserHistory.push(`/admin/import_csv/edit/${id}`);
        yield common.doneSaveRecord(result, 'CSV record was saved');
      }
    } else {
      yield common.showErrorSaveRecord(new Error('Error in saving: CSV Record'));
    }
  } catch (error) {
    yield common.showErrorSaveRecord(error);
  } 
}

export function* startImportSaga(app) {
  yield takeEvery(SagasType.START_CSV_IMPORT, startImport, app);
}
function* startImport(app, action) {
  const { user } = yield select();
  const { id, reference_id } = action;
  yield put({ type: SagasType.CSV_IMPORT_START_INPROGRESS, id });
  try {
    const doc = yield call(api.startCSVImport, app, { id, user });
    if(doc) {
      yield callFetchCSVRecordForEdit(app, { id, silent: true });
      yield put({ type: SagasType.CSV_IMPORT_START_DONE, id });
      browserHistory.push('/admin/job_status');
      yield take('FETCH_LIST_JOB');
      yield put(change('JobSearchForm', 'reference_id', reference_id));
    }
  } catch(error) {
    yield put({ type: SagasType.CSV_IMPORT_START_ERROR, id, error });
  }
}
